import * as UI from 'constants/ui';

export interface SetUserIsTabbingAction {
  type: typeof UI.SET_USER_IS_TABBING;
}

export interface UnsetUserIsTabbingAction {
  type: typeof UI.UNSET_USER_IS_TABBING;
}

export function setUserIsTabbing(): SetUserIsTabbingAction {
  return { type: UI.SET_USER_IS_TABBING };
}

export function unsetUserIsTabbing(): UnsetUserIsTabbingAction {
  return { type: UI.UNSET_USER_IS_TABBING };
}
